import api from "api";

const eventAnalytics = {
    // Público, sem auth — força isPublic=true pra nunca anexar Authorization,
    // mesmo se o visitante estiver logado (ex: produtor vendo o próprio evento).
    track: (eventId, type, sessionId) => {
        return api(false, true).post(`/events/${eventId}/track`, {
            type,
            session_id: sessionId,
        });
    },

    // Autenticado, só o dono do evento — api() padrão já anexa o Bearer token.
    // `period`: today | yesterday | 7d | 14d | 30d | all (sem ele a API usa 30d).
    getAnalytics: (eventId, period) => {
        return api().get(`/events/${eventId}/analytics`, { params: period ? { period } : {} });
    },
}

export default eventAnalytics;
